import React, { useEffect, useState } from "react";
import FootageCreateNTF from "./footage/leasing.f.createntf";
import { Auth, Storage } from "aws-amplify";
import FootageTableMain from "./footage/leasing.f.tablemain";
import { useParams } from "react-router-dom";
import FootageCreateTF from "./footage/leasing.f.createtf";
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";
import CelesFloatingInputState from "./components/leasing.c.celesfloatinginputstate";
import FootageSearch from "./footage/leasing.f.search";
import FootageFilter from "./footage/leasing.f.filter";
import FootagePagination from "./footage/leasing.f.pagination";
import { useSelector } from "react-redux";
import { prePareQueryRequest } from "./utils/leasing.u";
import ContainerContent from "components/Container/ContainerContent";
import {
  LEASING_REQUEST_PURPOSE_OPTIONS,
  LIMIT_OPTIONS,
  STATUS_OPTIONS,
} from "./constrant/leasing.ct.options";
import Skeleton from "react-loading-skeleton";
import DataEmpty from "../DataEmpty";
import _ from "lodash";
import FootageExportRequest from "./footage/leasing.f.exportRequest";
import FootageIssueAsk from "components/Leasing/footage/leasing.f.issueAsk";
import { SubmitLocalStorageSearch } from "../../function";
import API from "./api/api.main";
import axios from "axios";

const today = getCurrentLocalDateTime();

let source = axios.CancelToken.source();

function LeasingLoanMain() {
  const getDefaultQuery = () => {
    const today = getCurrentLocalDateTime();
    const objQuery = {
      Limit: LIMIT_OPTIONS[0],
      loan_id: "",
      ScanIndexForward: false,
      status: STATUS_OPTIONS[1],
      category: LEASING_REQUEST_PURPOSE_OPTIONS[0],
      min: "",
      max: "",
      fields: "-installments",
    };
    return objQuery;
  };

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [date, setDate] = useState("2022-01-01");
  const [isChange, setIsChange] = useState(false);
  const [searchBy, setSearchBy] = useState("phone_number");
  const [formQuery, setFormQuery] = useState(getDefaultQuery());
  const [formLastItem, setFormLastItem] = useState(null);
  const [countRecord, setCountRecord] = useState({ ACTIVE: 0 });
  const [currentCountRecord, setCurrentCountRecord] = useState("ACTIVE");
  const [loadingCountRecord, setLoadingCountRecord] = useState(true);
  const [leasings, setLeasings] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageType, setPageType] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);
  const [prevLeasings, setPrevLeasings] = useState([]);

  const searchBar = useSelector((state) => state.searchBar);
  const { user } = useSelector((state) => state.initializeApp);

  const params = useParams();

  useEffect(() => {
    fetchLeasingLoan(getDefaultQuery());
    setCurrentCountRecord(new Date().getTime());
  }, []);

  useEffect(() => {
    if (pageType === "NEXT") {
      setPrevLeasings(_.cloneDeep(leasings));
    }
  }, [pageIndex]);

  const fetchLeasingLoan = async (
    query,
    firstLoading = true,
    isSort = false,
    paSearchBar = searchBar,
    paSearchBy = searchBy
  ) => {
    try {
      setLoading(firstLoading);
      let localQuery = !query ? formQuery : query;
      const data = await API.get("MoneyHubAdmin", "/leasing/loan", {
        queryStringParameters: {
          ...prePareQueryRequest(
            _.cloneDeep(localQuery),
            paSearchBy,
            paSearchBar
          ),
          reserveByAdminName: user.username,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
        cancelToken: source?.token,
      });

      let leasing_loans = data?.leasing_loans;
      if (isSort) {
        leasing_loans = leasing_loans?.reverse();
      }

      setLeasings(leasing_loans);
    } catch (error) {
      console.log("fetch leasing request error", error);
    } finally {
      setLoading(false);
    }
  };

  const onSearchBy = (value) => {
    setSearchBy(value);
  };

  const onChangeFormQuery = (e) => {
    const { name, value } = e.target;
    setFormQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onChangeFormDate = (name) => (date, dateString) => {
    setFormQuery((prev) => {
      return {
        ...prev,
        [name]: date,
      };
    });
  };

  const onChangeSelect = (typeSelect) => (e) => {
    setFormQuery((prev) => {
      return {
        ...prev,
        [typeSelect]: e,
      };
    });
  };

  const onClickPrevPageEmpty = async () => {
    setLeasings(_.cloneDeep(prevLeasings));
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
  };

  return (
    <div className="bg-gray-100 px-6 pt-20 h-screen overflow-hidden">
      <div className="w-full mb-2 lg:flex items-center">
        <FootageSearch
          primaryKey="loan_id"
          searchBy={searchBy}
          onSearchBy={onSearchBy}
        />
      </div>

      <div className="flex items-center">
        {/* {!isTransfer && (
          <FootageCompleteAllRequest
            isTransfer={isTransfer}
            refetch={fetchLeasingRequest}
            formQuery={formQuery}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
        )} */}
        <FootageExportRequest
          isLoan
          countRecord={countRecord}
          currentCountRecord={currentCountRecord}
          setCurrentCountRecord={setCurrentCountRecord}
          isTransfer={false}
          setLoadingCountRecord={setLoadingCountRecord}
          setCountRecord={setCountRecord}
          refetch={fetchLeasingLoan}
          formQuery={formQuery}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          searchBy={searchBy}
        />
        <FootageIssueAsk selectedRows={selectedRows} />
      </div>
      <FootageFilter
        isLoan
        setCurrentCountRecord={setCurrentCountRecord}
        isTransfer={false}
        onChangeFormDate={onChangeFormDate}
        getDefaultQuery={getDefaultQuery}
        formQuery={formQuery}
        setFormQuery={setFormQuery}
        onChangeSelect={onChangeSelect}
        onChangeFormQuery={onChangeFormQuery}
        refetch={fetchLeasingLoan}
      />
      <div className="mt-6 ">
        {!leasings.length && !loading ? (
          pageType === "NEXT" ? (
            <ContainerContent>
              <div className="text-gray-700 font-bold text-xl w-full text-center mt-20">
                สิ้นสุดรายการ
              </div>
              <div className="w-full mt-2 flex items-center">
                {" "}
                <button
                  className="bg-blue-500 text-xl p-4  mx-auto text-white mt-2 "
                  onClick={onClickPrevPageEmpty}
                >
                  ย้อนกลับ
                </button>
              </div>
            </ContainerContent>
          ) : (
            <ContainerContent>
              <DataEmpty />
            </ContainerContent>
          )
        ) : (
          <React.Fragment>
            <div className="flex justify-between items-center mb-1">
              <div className="flex space-x-1">
                {loadingCountRecord ? (
                  <div className="w-12 mr-2">
                    <Skeleton />
                  </div>
                ) : (
                  <div>{countRecord[currentCountRecord]}</div>
                )}
                <div>Records</div>
              </div>
              <FootagePagination
                primaryKey="loan_id"
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
                setPageType={setPageType}
                pageType={pageType}
                countRecords={countRecord}
                leasings={leasings}
                formQuery={formQuery}
                setFormQuery={setFormQuery}
                refetch={fetchLeasingLoan}
                onChangeSelect={onChangeSelect}
                searchBy={searchBy}
              />
            </div>
            <FootageTableMain
              isChange={isChange}
              date={date}
              category={String(params.category).toUpperCase()}
              refetch={fetchLeasingLoan}
              loading={loading}
              leasings={leasings}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              env="production"
            />
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default LeasingLoanMain;
